/**
 * VoxPont2 variant title — Federo heading replacing the generic VoxPont logo image.
 *
 * WHAT: Renders the variant name as a Federo title at all screen sizes, matching the
 *       text-title variants (20–70/100).
 * WHY: VoxPont2 keeps its own title component so it does not import from carecompris/other
 *      variants; the name comes from VOXPONT2_CONFIG.displayTitle.
 * Coupling: VoxPont2LanguageSelector, VOXPONT2_CONFIG.displayTitle.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { VOXPONT2_CONFIG } from '../voxpont2Config';

const VOXPONT_VARIANT_TITLE_COLOR = '#1b4584';

/**
 * @param {Object} props
 * @param {object} [props.sx] - Extra MUI sx overrides applied to the title.
 */
function VoxPont2Logo({ sx }) {
  return (
    <Typography
      variant="h5"
      component="h1"
      sx={{
        fontFamily: '"Federo", serif',
        color: VOXPONT_VARIANT_TITLE_COLOR,
        textAlign: 'center',
        fontWeight: 600,
        lineHeight: 1.25,
        ...sx,
      }}
    >
      {VOXPONT2_CONFIG.displayTitle}
    </Typography>
  );
}

VoxPont2Logo.propTypes = {
  sx: PropTypes.object,
};

const VoxPont2LogoExport = VoxPont2Logo;
export default VoxPont2LogoExport;
